import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue'
import DocsTOC from './DocsTOC.vue'
import Documentation from './Documentation.vue'
import { routeQueue } from '../../router'
import { docsSidebarOpen, docsTocOpen, docsCurrentFile, openSidebarLink } from '@/helpers/docs.helper'


export default /*#__PURE__*/_defineComponent({
  __name: 'DocsSidebar',
  setup(__props) {

const docs = ref()
const names = ref()
const width = 500

onMounted(async () => {
  docs.value = (await import('./docs')).default
  names.value = docs.value.names
})

const newTabLink = computed(() => {
  if (!docsCurrentFile.value) {
    return ''
  }
  let link = docsCurrentFile.value
  if (!link.startsWith('/')) {
    link = '/' + link
  }
  return '/documentation' + link
})

function openTOC () {
  docsTocOpen.value = true
  docsSidebarOpen.value = false
}

function closeTOC () {
  docsTocOpen.value = false
  docsSidebarOpen.value = true
}


return { __sfc: true,docs, names, width, newTabLink, openTOC, closeTOC, DocsTOC, Documentation, docsSidebarOpen, docsTocOpen, docsCurrentFile, openSidebarLink }
}

})